/**
 * Minimal i18n — detects browser locale and returns Spanish strings
 * for the most critical user-facing copy if lang is Spanish (es-*).
 *
 * Add more keys as the app grows; keep English as fallback.
 */

const lang = navigator.language?.toLowerCase() || '';
export const isSpanish = lang.startsWith('es');

const strings = {
  en: {
    // Onboarding
    welcome_title: 'Welcome to Joystance',
    welcome_sub: 'Your city is alive. See what\'s happening around you right now.',
    onboarding_lets_go: 'Let\'s go',
    onboarding_skip: 'Skip setup, jump straight in',

    onboarding_name_title: 'What should we call you?',
    onboarding_name_sub: 'Pick something fun. You can always change it later.',
    onboarding_name_placeholder: 'Your nickname...',
    onboarding_continue: 'Continue',

    onboarding_location_title: 'Enable location',
    onboarding_location_sub: 'See pins, events, and people near you.',
    onboarding_location_privacy: '🔒 You stay in control — choose your precision level and change it anytime in settings.',
    onboarding_location_exact: 'Share my location (Recommended)',
    onboarding_location_approx: 'Approximate only (~150m)',
    onboarding_location_skip: 'Skip for now — you can enable this anytime later',

    onboarding_done_title: 'You\'re all set!',
    onboarding_done_sub: 'What do you want to do first?',

    // Settings
    invite_title: 'Invite Friends',
    invite_sub: 'Share Joystance — your friend gets 25 bonus XP',
    invite_copied: 'Copied!',
    invite_text: 'Join me on Joystance — find people & events near you in real time! 📍',
  },
  es: {
    welcome_title: 'Bienvenido a Joystance',
    welcome_sub: 'Tu ciudad está viva. Descubre lo que está pasando cerca de ti ahora mismo.',
    onboarding_lets_go: 'Empezar',
    onboarding_skip: 'Saltar configuración, entrar directamente',

    onboarding_name_title: '¿Cómo te llamamos?',
    onboarding_name_sub: 'Elige algo divertido. Puedes cambiarlo cuando quieras.',
    onboarding_name_placeholder: 'Tu apodo...',
    onboarding_continue: 'Continuar',

    onboarding_location_title: 'Activar ubicación',
    onboarding_location_sub: 'Ve pines, eventos y personas cerca de ti.',
    onboarding_location_privacy: '🔒 Tú controlas todo — elige el nivel de precisión y cámbialo cuando quieras en ajustes.',
    onboarding_location_exact: 'Compartir mi ubicación (Recomendado)',
    onboarding_location_approx: 'Aproximada (~150m)',
    onboarding_location_skip: 'Saltar por ahora — puedes activarlo más tarde en ajustes',

    onboarding_done_title: '¡Todo listo!',
    onboarding_done_sub: '¿Qué quieres hacer primero?',

    invite_title: 'Invitar amigos',
    invite_sub: 'Comparte Joystance — tu amigo recibe 25 XP de bono',
    invite_copied: '¡Copiado!',
    invite_text: '¡Únete a mí en Joystance — encuentra personas y eventos cerca en tiempo real! 📍',
  },
};

type StringKey = keyof typeof strings.en;

export function t(key: StringKey): string {
  if (isSpanish) {
    return (strings.es as any)[key] ?? strings.en[key];
  }
  return strings.en[key];
}
